import React, { useState } from "react";

import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Document, Page } from "react-pdf";

import { LoadingField, PDFField, PdfContainer, PreviewTitle } from "./styles";

interface Props {
  buffer?: Blob;
  loading?: boolean;
}

export const PdfView = (props: Props) => {
  const { buffer, loading } = props;
  const [page, setPage] = useState<number>(1);
  const { t: translate } = useTranslation();

  const onDocumentSucess = (pdf: { numPages: number }) => {
    setPage(pdf?.numPages || 1);
  };

  const renderPdf = () => {
    if (loading)
      return (
        <LoadingField
          justifyContent={"center"}
          alignItems={"center"}
          display={"flex"}
          flexDirection={"column"}
        >
          <CircularProgress size={40} />
        </LoadingField>
      );

    return (
      <PDFField>
        <Box
          justifyContent={"center"}
          alignItems={"center"}
          display={"flex"}
          flexDirection={"column"}
        >
          <Document file={buffer} onLoadSuccess={onDocumentSucess}>
            <Page pageNumber={page} renderTextLayer={false} renderAnnotationLayer={false}></Page>
          </Document>
        </Box>
      </PDFField>
    );
  };

  return (
    <PdfContainer>
      <PreviewTitle>{translate("previewOnSSCCLabel")}</PreviewTitle>
      {renderPdf()}
    </PdfContainer>
  );
};
